<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ pageText[routeName].mainTitle }}</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
    <el-form
      class="full_page page_padding_top"
      :model="formsData.supportForm"
      :rules="formsData.supportForm.rules"
      :ref="(el) => (formsData.supportForm.ref = el)"
      :label-position="'top'"
      @submit.prevent="submit('supportForm')"
    >
      <div
        class="form_text"
        :class="routeName == 'report' ? 'message_text' : ''"
      >
        <div class="text">
          {{ pageText[routeName].messageTitle }}
        </div>
      </div>
      <div class="image_text_comp" v-if="routeName == 'report'">
        <div class="image_wrapper">
          <el-avatar
            :size="'small'"
            shape="square"
            :src="reportUserData.image"
            v-if="reportUserData.image"
          />
          <el-avatar
            :size="'small'"
            shape="square"
            icon="el-icon-user-solid"
            v-else
          ></el-avatar>
        </div>
        <div class="text_wrapper">
          <div class="main_text">{{ reportUserData.name }}</div>
        </div>
      </div>
      <div class="shift_card" v-if="routeName == 'dispute'">
        <div class="image_text_comp" v-if="shift.locum">
          <div class="image_wrapper">
            <el-avatar
              :size="'small'"
              :shape="'circle'"
              :src="shift.locum.image"
              v-if="shift.locum.image"
            />
            <el-avatar
              :size="'small'"
              :shape="userRole == 'locum' ? 'square' : 'circle'"
              icon="el-icon-user-solid"
              v-else
            ></el-avatar>
          </div>
          <div class="text_wrapper">
            <div class="main_text">{{ shift.locum.name }}</div>
            <div v-if="isUS" class="additional_text">
              {{ shift.locum.settings.nabpProfileId  + " " + (shift.locum.settings.nabpProfileExpiryDate ? shift.locum.settings.nabpProfileExpiryDate : '') }}
            </div>
            <div v-else class="additional_text">
              {{ formatAhpraDisplay(shift.locum) }}
            </div>
          </div>
        </div>
        <div class="shift_info">
          <div class="info_wrapper">
            <div class="info_value">
              {{ $moment(shift.date, "YYYY-MM-DD").format("dddd, D MMMM") }}
            </div>
          </div>
          <div class="info_wrapper">
            <div class="info_value" :class="shift.statusClass">
              <div class="day_time">
                <span>{{
                  $moment(shift.startTime, "HH:mm").format("h:mm A")
                }}</span>
                -
                <span>{{
                  $moment(shift.endTime, "HH:mm").format("h:mm A")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-form-item prop="description">
        <el-input
          type="textarea"
          :autosize="{ minRows: 7 }"
          :placeholder="pageText[routeName].messagePlaceholder"
          v-model="formsData.supportForm.description.value"
        >
        </el-input>
      </el-form-item>

      <template v-if="routeName == 'support'">
        <div class="form_text">
          <div class="text">
            Attach screenshot (optional)
          </div>
        </div>
        <el-form-item prop="screenshots">
          <el-upload
            class="uploader-support "
            :ref="(el) => (formsData.supportForm.screenshots.ref = el)"
            :action="BASE_URL + '/feedback'"
            name="screenshots"
            list-type="picture"
            :thumbnail-mode="true"
            :auto-upload="false"
            :multiple="true"
            :limit="3"
            @remove="imageRemove"
            @change="imageChange"
            :before-upload="beforeUpload"
            @exceed="imageLimit"
            :disabled="formsData.supportForm.screenshots.disabled"
            :drag="true"
          >
            <!-- <el-button
              class="image_upload"
              type="transparent"
              v-if="!formsData.supportForm.screenshots.disabled"
            >
              <span class="image"
                ><span class="locumate_icons locumate_icon-picture"></span
              ></span>
              <span class="text">Select image</span>
            </el-button> -->
            <div class="file-uploader"                                       >
                <div class="file-uploader-icon">
                    <img :src="require('@/assets/img/icons/upload.svg')" alt="upload" />
                </div> 
                <div class="file-uploader-title">
                    Select image files
                </div>
                <div class="file-uploader-description">
                  Please upload only JPEG or PNG.
                </div>
            </div>

          

            <template #file="{ file }">
              <div v-if="file.raw.type=='application/pdf'" class="el-upload-list__item-body">
                                <img class="el-upload-list__item-body-thumbnail" :src="require('@/assets/img/icons/pdf.svg')" />
                                <div class="el-upload-list__item-body-text">
                                    <span class="title" size="large">{{ file.name }}</span>
                                </div>
                            </div>
              <div class="el-upload-list__item-body" v-else>
                  <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt=""/>
                  <div class="el-upload-list__item-body-text">
                      <span class="title" size="large">{{ file.name }}</span>
                      
                  </div>
              </div>
              <div class="el-upload-list__item-actions">
                  <button class="el-upload-list__item-actions-action" @click.prevent="imageRemove(file, fileList)">
                      <img :src="require('@/assets/img/icons/trash.svg')" />
                  </button>
              </div>
          </template>
          </el-upload>
        </el-form-item>
      </template>
      <template v-if="routeName == 'support'">
        
        <div v-if="formsData.supportForm.userData.supportSite" class="w-full text-center mb-3 support-link">
          <a :href="`https://${formsData.supportForm.userData.supportSite}`" target="_blank">Support Site</a>
        </div>
      </template>
      
      <el-form-item class="button_submit mb0">
        <el-button
          class="submit_page w-100"
          type="blue"
          @click="submit('supportForm')"
          :disabled="formsData.supportForm.disabled"
        >
          {{ pageText[routeName].submitButton }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  </div>
</template>

<script>
import {
  onMounted,
  inject,
  nextTick,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import { ElMessage } from "@/components/Vendor/Element";

import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { formatAhpraDisplay } from "@/helpers/ahpra/ahpraDisplay.js";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);

    const routeName = $route.name;
    const reportUserData = $store.getters.getReportData.userData;
    const shift = $store.getters.getReportData.shiftData;

    const pageText = {
      support: {
        mainTitle: "Support",
        messageTitle: "How can we help?",
        messagePlaceholder: "Add your support enquiry here",
        submitButton: "Submit Request",
      },
      report: {
        mainTitle: "Report",
        messageTitle: "Send a report about:",
        messagePlaceholder: "Add a message to the report here",
        submitButton: "Submit Report",
      },
      dispute: {
        mainTitle: "Dispute",
        messageTitle: "Send a dispute about shift:",
        messagePlaceholder: "Add a message to the dispute here",
        submitButton: "Submit Dispute",
      },
    };

    const BASE_URL = process.env.VUE_APP_BASEURL;

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;

    const isUS = isUSRegion();

    const formsDataArray = {
      supportForm: {
        description: {
          value: "",
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "supportMessage",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    if (routeName == "support") {
      const dataArray = {
        userData: userData,
        screenshots: {
          ref: null,
          disabled: false,
          value: [],
          limit: 3,
          errors: null,
        },
      };
      Object.assign(formsDataArray.supportForm, dataArray);
    }

    const checkFilesLimit = (length, limit) => {
      if (length >= limit) {
        return true;
      } else return false;
    };

    const imageRemove = (file) => {
      formsData.supportForm.screenshots.value.splice(
        formsData.supportForm.screenshots.value.indexOf(file),
        1
      );
      formsData.supportForm.screenshots.disabled = checkFilesLimit(
        formsData.supportForm.screenshots.value.length,
        formsData.supportForm.screenshots.limit
      );
    };

    const imageChange = (file, fileList) => {
      formsData.supportForm.screenshots.value = fileList;
      formsData.supportForm.screenshots.disabled = checkFilesLimit(
        formsData.supportForm.screenshots.value.length,
        formsData.supportForm.screenshots.limit
      );
    };

    const imageLimit = (files, fileList) => {
      let errors = `The limit is ${
        formsData.supportForm.screenshots.limit
      }, you selected ${
        files.length
      } files this time, add up to ${files.length + fileList.length} totally`;
      setFieldError("supportForm", "screenshots", errors);
      checkFormValidation("supportForm", true, "screenshots");
      nextTick(() => {
        setFormValidation("supportForm", "screenshots", true);
      });
    };

    const beforeUpload = (file) => {
      console.log(file);
    };

    const goBack = () => {
      if (routeName == "report") {
        $router.push({
          name: $store.getters["getPageBack"]({
            state: "report",
            remove: true,
          }).name,
        });
      } else if (routeName == "dispute") {
        $router.push({
          name: $store.getters["getPageBack"]({
            state: "dispute",
            remove: true,
          }).name,
        });
      } else {
        $router.push({
          name: "profile",
        });
      }
    };

    const goNext = () => {
      $router.push({
        name: "home",
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_report_page");
      checkFormValidation("supportForm", false);
      setFormRefs();
    });

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let formValues = getFormValues(formName);
              if (routeName == "report") {
                formValues.user_id = $route.params.userId;
                formValues.reason = formValues.description;
                delete formValues.description;
                if (shift) {
                  formValues.shift_id = shift.id;
                }
              }
              const form = new FormData();
              Object.keys(formValues).map(function(key) {
                if (
                  formValues[key] instanceof Array &&
                  formValues[key].length
                ) {
                  formValues[key].forEach((x, i) =>
                    form.append(`${key}[${i}]`, x)
                  );
                } else {
                  form.append(key, formValues[key]);
                }
              });

              let message = "";
              if (routeName == "report") {
                await $store.dispatch("SEND_REPORT", form);
                goBack();
                message = "Thanks for submitting the report";
              } else if (routeName == "dispute") {
                await $store.dispatch("DISPUTE_SHIFT", {
                  shiftId: shift.id,
                  params: {
                    reason: formValues.description,
                  },
                });
                goNext();
                message = "Thanks for submitting the dispute";
              } else {
                $store.dispatch("SEND_SUPPORT", form);
                goNext();
                message = "Thank you for contacting support";
              }
              ElMessage({
                type: "success",
                message: message,
              });
            } catch (error) {
              let message = "";
              if (routeName == "report") {
                message = "The report was not sent";
              } else if (routeName == "dispute") {
                message = "The dispute was not sent";
              } else {
                message = "Support request was not sent";
              }
              if(message != 'The report was not sent'){
                ElMessage({
                  type: "error",
                  message: message,
                });
              }
              
              console.log(error);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFieldError,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      pageText,
      routeName,
      reportUserData,
      formsData,
      userRole,
      goBack,
      submit,
      imageRemove,
      imageChange,
      beforeUpload,
      imageLimit,
      BASE_URL,
      shift,
      isUS,
      formatAhpraDisplay,
    };
  },
};
</script>
